import { request } from 'utils/request';
import { header } from 'utils/auth';

const fetchMyautoiqSegmentSettingsFromAPI = async ({
  manufacturerId,
}: {
  manufacturerId: string;
}): Promise<any> => {
  try {
    const requestURL = `/api/v2/myautoiq-settings/manufacturer=${manufacturerId}?type=DEALER_SEGMENTS_CONFIG`;
    const response: any = await request(requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
    });

    if (!response) {
      throw new Error('Failed to fetch myautoiq segment settings from API');
    }
    return await response;
  } catch (error) {
    console.error('Error fetching myautoiq segment settings:', error);
    throw error;
  }
};

const createMyautoiqSegmentSettingsFromAPI = async ({
  manufacturerId,
  data,
}: {
  manufacturerId: string;
  data: any;
}): Promise<any> => {
  try {
    const requestURL = `/api/v2/myautoiq-settings/manufacturer=${manufacturerId}?type=DEALER_SEGMENTS_CONFIG`;
    const response: any = await request(requestURL, {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify(data),
    });

    if (!response) {
      throw new Error('Failed to create myautoiq segment settings from API');
    }
    const res = await response;
    const status = res?.statusCode ?? res?.myAutoIQ_status_code ?? res?.errorCode;
    const msg = res?.message ?? res?.myAutoIQ_error_message;
    if (typeof status === 'number' && status >= 400) {
      throw new Error(msg || 'Failed to create myautoiq segment settings');
    }
    return res;
  } catch (error) {
    console.error('Error creating myautoiq segment settings:', error);
    throw error;
  }
};

const updateMyautoiqSegmentSettingsFromAPI = async ({
  manufacturerId,
  settingsId,
  data,
}: {
  manufacturerId: string;
  settingsId: string;
  data: any;
}): Promise<any> => {
  try {
    const requestURL = `/api/v2/myautoiq-settings/manufacturer=${manufacturerId}/${settingsId}`;
    const response: any = await request(requestURL, {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify(data),
    });

    if (!response) {
      throw new Error('Failed to update myautoiq segment settings from API');
    }
    const res = await response;
    const status = res?.statusCode ?? res?.myAutoIQ_status_code ?? res?.errorCode;
    const msg = res?.message ?? res?.myAutoIQ_error_message;
    if (typeof status === 'number' && status >= 400) {
      throw new Error(msg || 'Failed to update myautoiq segment settings');
    }
    return res;
  } catch (error) {
    console.error('Error updating myautoiq segment settings:', error);
    throw error;
  }
};

export const fetchMyautoiqSegmentSettings = async ({
  manufacturerId,
}: {
  manufacturerId: string;
}): Promise<any> => {
  return fetchMyautoiqSegmentSettingsFromAPI({ manufacturerId });
};

export const createMyautoiqSegmentSettings = async ({
  manufacturerId,
  data,
}: {
  manufacturerId: string;
  data: any;
}): Promise<any> => {
  return createMyautoiqSegmentSettingsFromAPI({ manufacturerId, data });
};

export const updateMyautoiqSegmentSettings = async ({
  manufacturerId,
  settingsId,
  data,
}: {
  manufacturerId: string;
  settingsId: string;
  data: any;
}): Promise<any> => {
  return updateMyautoiqSegmentSettingsFromAPI({
    manufacturerId,
    settingsId,
    data,
  });
};
